/* @flow */
import moment from 'moment';

import Td from 'components/UIKit/Table/Td';
import ParamsLink from 'components/Links/ParamsLink';
import BiospecimenIcon from 'components/icons/BiospecimenIcon';
import TrLink from '../TrLink';

export default function SamplesRow({
  children, router,
}: any): React.Element {
  const newQuery = { did: children.id };
  const isActiveItem = children.id
    && (router.location.query.did === children.id);

  return (
    <TrLink
      isActiveItem={isActiveItem}
      linkId={children.id}
      router={router}
      >
      <Td>
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <BiospecimenIcon style={{ marginRight: '.5rem' }} />
          {isActiveItem ? children.submitter_id : (
            <ParamsLink query={newQuery}>
              { children.submitter_id }
            </ParamsLink>
          )}
        </div>
      </Td>
      <Td style={{ textTransform: 'capitalize' }}>{ children.type }</Td>
      <Td>{ children.sample_type }</Td>
      <Td style={{ textTransform: 'capitalize' }}>{ (children._related_cases || []).map(x => x.submitter_id).join(', ') }</Td>
      <Td style={{ textTransform: 'capitalize' }}>{ children.state }</Td>
      <Td>{ moment(children.updated_datetime).format('ll') }</Td>
    </TrLink>
  );
}
